module.exports = __webpack_public_path__ + "img/20180408_152350-1024x867.d7e04528.jpg";